import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Row, Col, Modal, Switch } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import MediaManager from '../../Media/MediaManager';
import { useForm } from 'antd/es/form/Form';
import { useProducts } from './ProductStore';
import { useCategorys } from '../Categorys/CatStore';
import { useBrands } from '../Brands/BrandStore';
import { useModels } from '../Models/ModelStore';
import { useUnits } from '../Units/UnitStore';
import { MAIN_URL } from '../../../Constants';

const Add = () => {
    const [form] = useForm();
    let [main_img, setMain_img] = useState(null)
    let [gallery_img, setGallery_img] = useState([])
    let [modal, setModal] = useState(false)
    let [gal_modal, setGal_modal] = useState(false)
    let { categorys, getCategories } = useCategorys()
    let { brands, getBrands } = useBrands()
    let { models, getModels } = useModels()
    let { units, getUnits } = useUnits()
    let { createProduct } = useProducts()

    const handleSelect = (e) => {
        setMain_img(e)
    }
    useEffect(() => {
        getBrands()
        getModels()
        getUnits()
    }, [])

    const handleGallerySelect = (e) => {
        setGallery_img([...gallery_img, e])
    }
    useEffect(() => {
        form.setFieldsValue({
            img: main_img
        })
    }, [main_img])

    useEffect(() => {
        form.setFieldsValue({
            gallery: gallery_img
        })
        getCategories()
    }, [gallery_img])

    let handleGalDelete = (index) => {
        let newGal = gallery_img.filter((item, i) => i !== index)
        setGallery_img(newGal)
    }

    return (
        <>
            <Modal width={'80%'} open={modal} footer={null} onCancel={() => setModal(false)}>
                <MediaManager onSelect={handleSelect} />
            </Modal>
            <Modal width={'80%'} open={gal_modal} footer={null} onCancel={() => setGal_modal(false)}>
                <MediaManager onSelect={handleGallerySelect} />
            </Modal>

            <Form
                form={form}
                layout="vertical"
                onFinish={(v) => {
                    let vars = JSON.parse(localStorage.getItem('variation'))
                    let data = { ...v, img: main_img, gallery: JSON.stringify(gallery_img), items: vars }
                    createProduct(data)
                }}
                autoComplete="off"
            >
                <fieldset>
                    <legend>Asosiy Ma'lumotlar</legend>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="nameuz"
                                label="Nomi (UZ)"
                                rules={[{ required: true, message: 'Please input name in Uzbek!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="nameru"
                                label="Nomi (RU)"
                                rules={[{ required: true, message: 'Please input name in Russian!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item
                        name="category_id"
                        label="Kategoriya"
                        rules={[{ required: true, message: 'Please select category!' }]}
                    >
                        <Select
                            showSearch
                            placeholder="Select a category"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {categorys.map((unit) => (
                                <Select.Option key={unit.id} value={unit.id}>
                                    {unit.nameuz}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="descuz"
                        label="Izoh (UZ)"
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>

                    <Form.Item
                        name="descru"
                        label="Izoh (RU)"
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>

                    <Form.Item
                        name="img"
                        label="Asosiy rasm"
                    >
                        <Input readOnly suffix={<Button type="primary" onClick={() => setModal(true)}>Fayl yuklash</Button>} />
                    </Form.Item>
                    {main_img && <img src={main_img} alt="" style={{ width: '100px' }} />}

                    <Form.Item
                        name="gallery"
                        label="Galereya"
                    >
                        <Input disabled suffix={<Button type="primary" onClick={() => setGal_modal(true)}>Fayl yuklash</Button>} />
                    </Form.Item>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {gallery_img.length > 0 && gallery_img.map((item, index) => (
                            <div style={{ position: 'relative' }} key={index}>
                                <img src={MAIN_URL + '/' + item} alt="" style={{ width: '100px', height: '100px', objectFit: 'cover', margin: '5px' }} />
                                <Button icon={<DeleteOutlined />} shape='circle' type='primary' size='small' danger onClick={() => handleGalDelete(index)} style={{ position: 'absolute', top: '0px', right: '0px', border: '1px solid #fff' }} />
                            </div>
                        ))}
                    </div>


                </fieldset>
                <fieldset>
                    <legend>Qo'shimcha parametrlar</legend>
                    <Row gutter={16}>
                        <Col span={6}>
                            <Form.Item
                                name="min_count"
                                label="Minimal qoldiq"
                            >
                                <Input type='number' />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="brand_id"
                                label="Marka"
                            >
                                <Select
                                    showSearch
                                    placeholder="Marka"
                                    mode="multiple"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {brands.map((brand) => (
                                        <Select.Option key={brand.id} value={brand.id}>
                                            {brand.nameuz}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="model_id"
                                label="Model"
                            >
                                <Select
                                    showSearch
                                    mode="multiple"
                                    placeholder="Model"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {models.map((model) => (
                                        <Select.Option key={model.id} value={model.id}>
                                            {model.nameuz}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="unit_id"
                                label="Birlik"
                            >
                                <Select
                                    showSearch
                                    placeholder="Birlik"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {units.map((unit) => (
                                        <Select.Option key={unit.id} value={unit.id}>
                                            {unit.nameuz}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="newto"
                                label="Yangi qilib belgilash"
                                valuePropName="checked"
                            >
                                <Switch />
                            </Form.Item>
                        </Col>
                    </Row>
                </fieldset>

                <fieldset>
                    <legend>SEO Ma'lumotlar</legend>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="meta_desc"
                                label="SEO izoh"
                            >
                                <Input.TextArea rows={2} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="meta_keywords"
                                label="SEO kalit so'zlar"
                            >
                                <Input.TextArea rows={2} />
                            </Form.Item>
                        </Col>
                    </Row>
                </fieldset>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Qo'shish
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
};

export default Add;